// components/HolidayCalendar.tsx
import React, { useEffect, useState } from 'react';
import Main from "../components/custom/Main";
import {
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  addDays,
  format,
  isSameDay,
  isSameMonth,
  
  parseISO,
} from 'date-fns';

import { getHolidays } from '../services/HolidayService';
import { Holiday } from '../types/Holiday';
import PageContainer from '../components/custom/PageContainer';

const HolidayCalendar: React.FC = () => {
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [holidays, setHolidays] = useState<Holiday[]>([]);

  useEffect(() => {
    getHolidays().then((data) => {
      setHolidays(data);
    });
  }, []);

  const renderHeader = () => {
    return (
      <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px' }}>
        <button onClick={() => setCurrentMonth(prev => addDays(prev, -30))}>← Prev</button>
        <h2>{format(currentMonth, 'MMMM yyyy')}</h2>
        <button onClick={() => setCurrentMonth(prev => addDays(prev, 30))}>Next →</button>
      </div>
    );
  };

  const renderDays = () => {
    const days = [];
    const weekStart = startOfWeek(currentMonth);

    for (let i = 0; i < 7; i++) {
      days.push(
        <div key={i} style={{ flex: 1, textAlign: 'center', fontWeight: 'bold' }}>
          {format(addDays(weekStart, i), 'EEE')}
        </div>
      );
    }

    return <div style={{ display: 'flex',borderBottom: '1px solid #ccc' }}>{days}</div>;
  };

  const renderCells = () => {
    const monthStart = startOfMonth(currentMonth);
    const monthEnd = endOfMonth(monthStart);
    const startDate = startOfWeek(monthStart);
    const endDate = endOfWeek(monthEnd);

    const rows = [];
    let days = [];
    let day = startDate;

    while (day <= endDate) {
      for (let i = 0; i < 7; i++) {
        const currentDay = day;
        const holiday = holidays.find(h =>
          isSameDay(
            parseISO(`${h.year}-${h.month.padStart(2, '0')}-${h.day.padStart(2, '0')}`),
            currentDay
          )
        );

        days.push(
          <div
            key={currentDay.toString()}
            style={{
              flex: 1,
              border: '1px solid #ccc',
              height: '80px',
              padding: '4px',
              backgroundColor: holiday ? '#ffefef' : isSameMonth(currentDay, monthStart) ? 'white' : '#f0f0f0',
              color: holiday ? 'red' : 'black',
              fontSize: '14px',
            }}
          >
            <div>{format(currentDay, 'd')}</div>
            {holiday && <div style={{ fontSize: '10px' }}>{holiday.reason}</div>}
          </div>
        );

        day = addDays(day, 1);
      }

      rows.push(<div key={day.toString()} style={{ display: 'flex' }}>{days}</div>);
      days = [];
    }

    return <div>{rows}</div>;
  };

  return (
    <Main>
    <PageContainer title='View Holiday'>
      {renderHeader()}
      {renderDays()}
      {renderCells()}
      </PageContainer>
     </Main>
  );
};

export default HolidayCalendar;
